// extracted by mini-css-extract-plugin
export var label = "sectionLabel-module--label--2CEoS";
export var title = "sectionLabel-module--title--1JVAu";